import { PayrollExecutionDto, PayrollExportDto, PayrollReviewDto } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import { WebApiRequest, HTTP_GET, HTTP_PUT } from "tools/webservice";

export const reviewPayPeriod = (payPeriodId: number, successCallback: (dto: PayrollReviewDto) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/payroll/review/${payPeriodId}`,
  successCallback,
  mountedRef,
});

export const calculatePayPeriod = (payPeriodId: number, successCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/payroll/calculate/${payPeriodId}`,
  successCallback,
  mountedRef,
});

export const getExecutions = (payPeriodId: number, successCallback: (list: PayrollExecutionDto[]) => void, failedCallback: () => void,  mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/payroll/executions/${payPeriodId}`,
  successCallback,
  errorCallback: failedCallback,
  mountedRef,
});

export const exportPayPeriod = (payPeriodId: number, successCallback: (dto: PayrollExportDto) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/payroll/export/${payPeriodId}`,
  successCallback,
  mountedRef,
});

export const closePayPeriod = (payPeriodId: number, successCallback: () => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/payroll/close/${payPeriodId}`,
  successCallback,
  mountedRef,
});
